export default {
    MenuProductList: (data) => window.axios.post('restaurantcategorymenus', data),
    RestaurantMenusItemDetails: (data) => window.axios.post('restaurant_menus_details', data),
    RestaurantInfo: (data) => window.axios.post('get_restaurant_detail', data),
    getQuickCheckoutItem: (data) => window.axios.post('get_quick_checkout_item', data),
    restaurantMenus: (data) => window.axios.post('restaurantmenus', data),
    verifyCart: (data) => window.axios.post('verify-cart', data),
}